
import { VueClassicModalPopUpViewModel } from '@/entities/VueClassicModalPopUpViewModel';
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';

@Component
class VueClassicModalPopUp extends Vue {
  @Prop() private modalPopUp!: VueClassicModalPopUpViewModel;

  private logoUrl = require('@/assets/Images/VentlaLogo/Ventla-Logo-White.svg');

  private Close(): void {
    this.$emit('close');
  }

  private Button1Click(): void {
    this.$emit('button1-click');
  }

  private Button2Click(): void {
    this.$emit('button2-click');
  }

  private ContinueClick(): void {
    this.$emit('continue-click');
  }
}

export default toNative(VueClassicModalPopUp);
